// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qhyg","col":"styles_col__1El4z","actions":"styles_actions__1GKFA","conflict":"styles_conflict__mFR-g"};